export const GET_KIOSK_STATUS_REQUEST = 'GET_KIOSK_STATUS_REQUEST';
export const GET_KIOSK_STATUS_SUCCESS = 'GET_KIOSK_STATUS_SUCCESS';
export const GET_KIOSK_STATUS_FAILURE = 'GET_KIOSK_STATUS_FAILURE';